export default "__VITE_ASSET__7oynBwVA__"